<template>
  <div>
    <van-nav-bar
      title="添加农资"
      left-arrow
      @click-left="$router.back()"
    />
    <van-form ref="form" class="form">
      <van-field :value="form.name" :rules="rules.agrData" label="农资" input-align="left">
        <template #input>
          <agr-box :agr-data="agrData" @add="popup.list=true" @remove="handleRemoveAgr" />
          <agr-select :visible.sync="popup.list" @select="handleSelectAgr" />
        </template>
      </van-field>
      <van-field :value="form.num" :rules="rules.unit" label="包装规格">
        <template #input>
          <div class="unit-box">
            <van-stepper
              v-model.number="form.num"
              :min="0"
              input-width="50px"
              decimal-length="2"
            />
            <wh-select-popup v-model="form.unit" :options="unitOptions" placeholder="单位" />
            <wh-select-popup v-model="form.pack" :options="packOptions" placeholder="单位" />
          </div>
        </template>
      </van-field>
      <van-field :value="form.count" :rules="rules.count" label="数量">
        <template #input>
          <van-stepper
            v-model.number="form.count"
            :min="0"
            input-width="80px"
          />
        </template>
      </van-field>
      <van-field :value="form.price" :rules="rules.price" label="单价(元)">
        <template #input>
          <van-stepper
            v-model="form.price"
            :min="0"
            :decimal-length="2"
            input-width="80px"
          />
        </template>
      </van-field>
      <wh-field-select-popup
        v-model="form.operator"
        :columns="operatorOptions"
        :rules="rules.operator"
        label="负责人"
      />
      <wh-field-time-popup
        v-model="form.date"
        :rules="rules.date"
        label="操作时间"
      />
    </van-form>
    <wh-sub-button @click="handleSub" />
  </div>
</template>

<script>
import AgrBox from '@/views/agrStock/components/AgrBox'
import AgrSelect from '@/views/agrStock/components/AgrSelect'
import { unitOptions, packOptions } from '@/constant/common'
import WhFieldSelectPopup from '@/components/public/WhFieldSelectPopup/WhFieldSelectPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhSelectPopup from '@/components/public/WhSelectPopup/WhSelectPopup'
import WhSubButton from '@/components/base/WhSubButton'
import dayjs from 'dayjs'
import api from '@/api'

export default {
  name: 'AgrAdd',
  components: { WhSubButton, WhFieldTimePopup, WhFieldSelectPopup, WhSelectPopup, AgrSelect, AgrBox },
  data() {
    const agrDataValidator = (value, rule) => {
      return !!this.agrData
    }
    const unitValidator = (value, rule) => {
      return !!this.form.num && !!this.form.unit && !!this.form.pack
    }
    return {
      unitOptions, packOptions,
      popup: {
        list: false
      },
      agrData: undefined,
      operatorOptions: [],
      form: {
        name: '',
        factory: '',
        type: '',
        num: 0,
        unit: '',
        pack: '',
        count: 0,
        price: 0,
        date: dayjs().format('YYYY-MM-DD HH:mm:00'),
        operator: ''
      },
      rules: {
        agrData: [
          { validator: agrDataValidator, message: '请选择农资' }
        ],
        unit: [
          { validator: unitValidator, message: '请选择完整的包装规格' }
        ],
        count: [
          { validator: val => val >= 0, message: '请输入农资数量' }
        ],
        operator: [
          { required: true, message: '请选择负责人' }
        ],
        date: [
          { required: true, message: '请选择时间' }
        ]
      }
    }
  },
  created() {
    this.getStaffList()
  },
  methods: {
    getStaffList() {
      api.getStaffList({ pageSize: 1000 }).then(({ data: { list }}) => {
        this.operatorOptions = list.map(i => {
          return i.name
        })
      })
    },
    handleSelectAgr(data) {
      this.agrData = data
      Object.assign(this.form, data)
    },
    handleRemoveAgr() {
      this.agrData = undefined
      this.form.name = ''
      this.form.factory = ''
      this.form.type = ''
    },
    handleSub() {
      this.$refs.form.validate().then(() => {
        const query = {
          ...this.form
        }
        query.num = query.num * 1000
        query.count = query.count * query.num
        api.createAgricultural(query).then(() => {
          this.$toast('添加成功')
          this.$router.push({ name: 'AgrList' })
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.unit-box {
  display: flex;
  flex-wrap: wrap;
}
.form {
  margin-top: 10px;
}
</style>
